// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.TableTitleWithCheckbox {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.TableTitleWithCheckbox .TableTitleWithCheckbox-checkboxContainer {
  width: 26px;
  height: 20px;
  margin: 0px 8px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.TableTitleWithCheckbox .TableTitleWithCheckbox-checkboxContainer .TableTitleWithCheckbox-index {
  display: inherit;
  color: var(--color_neutral_500);
  font-size: 14px;
}
.TableTitleWithCheckbox .TableTitleWithCheckbox-checkboxContainer .TerritoryAddToCheckbox {
  display: none;
  margin: 0px;
}
.TableTitleWithCheckbox:hover .TableTitleWithCheckbox-checkboxContainer .TableTitleWithCheckbox-index {
  display: none;
}
.TableTitleWithCheckbox:hover .TableTitleWithCheckbox-checkboxContainer .TerritoryAddToCheckbox {
  display: inherit;
}
.TableTitleWithCheckbox .TableTitleWithCheckbox-checkboxContainer:has(.TerritoryAddToCheckbox-active) .TableTitleWithCheckbox-index {
  display: none;
}
.TableTitleWithCheckbox .TableTitleWithCheckbox-checkboxContainer:has(.TerritoryAddToCheckbox-active) .TerritoryAddToCheckbox {
  display: inherit;
}

.TitleTableCell {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.TitleTableCell p {
  font-size: 14px;
  color: var(--color_neutral_800);
  margin-right: auto;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.TitleTableCell p span {
  font-size: 14px;
  color: var(--color_neutral_800);
}
.TitleTableCell .TableTitleWithCheckbox-textHighlight {
  font-weight: 800;
  background-color: transparent;
  color: var(--color_neutral_800);
}
.TitleTableCell span {
  font-size: 12px;
  color: var(--color_neutral_500);
}
.TitleTableCell-breadcrumb {
  height: 20px;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/territory/territory-title-table-cell/territory-title-table-cell.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAeF;AAbE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAeJ;AAbI;EACE,gBAAA;EACA,+BAAA;EACA,eAAA;AAeN;AAZI;EACE,aAAA;EACA,WAAA;AAcN;AARM;EACE,aAAA;AAUR;AAPM;EACE,gBAAA;AASR;AAHI;EACE,aAAA;AAKN;AAFI;EACE,gBAAA;AAIN;;AACA;EACE,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAEF;AAAE;EACE,eAAA;EACA,+BAAA;EACA,kBAAA;ED3DF,oBAAA;EACA,aC2DsB;ED1DtB,qBC0DsB;EDzDtB,4BAAA;EACA,gBAAA;EACA,sBANoC;ACoEtC;AALI;EACE,eAAA;EACA,+BAAA;AAON;AAHE;EACE,gBAAA;EACA,6BAAA;EACA,+BAAA;AAKJ;AAFE;EACE,eAAA;EACA,+BAAA;AAIJ;AADE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAGJ","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins.scss';\n\n.TableTitleWithCheckbox {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  .TableTitleWithCheckbox-checkboxContainer {\n    width: 26px;\n    height: 20px;\n    margin: 0px 8px 0px 0px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .TableTitleWithCheckbox-index {\n      display: inherit;\n      color: var(--color_neutral_500);\n      font-size: 14px;\n    }\n\n    .TerritoryAddToCheckbox {\n      display: none;\n      margin: 0px;\n    }\n  }\n\n  &:hover {\n    .TableTitleWithCheckbox-checkboxContainer {\n      .TableTitleWithCheckbox-index {\n        display: none;\n      }\n\n      .TerritoryAddToCheckbox {\n        display: inherit;\n      }\n    }\n  }\n\n  .TableTitleWithCheckbox-checkboxContainer:has(.TerritoryAddToCheckbox-active) {\n    .TableTitleWithCheckbox-index {\n      display: none;\n    }\n\n    .TerritoryAddToCheckbox {\n      display: inherit;\n    }\n  }\n}\n\n.TitleTableCell {\n  width: fit-content;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  p {\n    font-size: 14px;\n    color: var(--color_neutral_800);\n    margin-right: auto;\n    @include line-clamp(1);\n\n    span {\n      font-size: 14px;\n      color: var(--color_neutral_800);\n    }\n  }\n\n  .TableTitleWithCheckbox-textHighlight {\n    font-weight: 800;\n    background-color: transparent;\n    color: var(--color_neutral_800);\n  }\n\n  span {\n    font-size: 12px;\n    color: var(--color_neutral_500);\n  }\n\n  &-breadcrumb {\n    height: 20px;\n    display: flex;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
